const breakpointsConstants = {
  IS_DESKTOP: "(min-width: 1024px)",
  IS_MOBILE: "(max-width: 1023px)",
}

export default breakpointsConstants
